import { render, staticRenderFns } from "./importSuccess.vue?vue&type=template&id=3a8868a4&scoped=true"
import script from "./importSuccess.vue?vue&type=script&lang=js"
export * from "./importSuccess.vue?vue&type=script&lang=js"
import style0 from "./importSuccess.vue?vue&type=style&index=0&id=3a8868a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8868a4",
  null
  
)

export default component.exports